import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Intro } from "@/components/Intro";
import { Hero } from "@/components/Hero";
import { Promo } from "@/components/Promo";
import { Marquee } from "@/components/Marquee";
import { Gallery } from "@/components/Gallery";
import { Manifesto } from "@/components/Manifesto";
import { Process } from "@/components/Process";
import { Packages } from "@/components/Packages";
import { StyleQuiz } from "@/components/StyleQuiz";
import { Booking } from "@/components/Booking";
import { TerminStatus } from "@/components/TerminStatus";
import { Faq } from "@/components/Faq";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { scrollToId } from "@/lib/scroll";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const t = setTimeout(() => scrollToId(location.hash), 400);
      return () => clearTimeout(t);
    }
  }, [location.hash]);

  return (
    <div className="bg-ink text-white" data-testid="home-page">
      <Intro />
      <Navbar />
      <main>
        <Hero />
        <Promo />
        <Marquee />
        <Gallery />
        <Manifesto />
        <Process />
        <Packages />
        <StyleQuiz />
        <Booking />
        <TerminStatus />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
